// extracted by mini-css-extract-plugin
export default {"container":"EditListName_container__A1ZC1","input":"EditListName_input__Q2dKI"};